import { createAction, props } from '@ngrx/store';
import {UserInfoItem} from '@src/app/pages/Mitarbeiterverwaltung/userInfo.model';

export const loadUserInfoStart = createAction('MITARBEITERVERWALTUNG::LOAD_USERINFO_START' , props<{userId: number, showYears: number}>());
export const loadUserInfoSucceeded = createAction(
    'MITARBEITERVERWALTUNG::LOAD_USERINFO_SUCCEEDED',
    props<{ item: UserInfoItem[] }>(),
);
export const loadUserInfoFailed = createAction('MITARBEITERVERWALTUNG::LOAD_USERINFO_FAILED', props<{ error: Error }>());
